import { render, staticRenderFns } from "./SummaryCardRemoveItem.vue?vue&type=template&id=23e170d2&scoped=true&"
import script from "./SummaryCardRemoveItem.vue?vue&type=script&lang=js&"
export * from "./SummaryCardRemoveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e170d2",
  null
  
)

export default component.exports